var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    { attrs: { border: "", data: _vm.tableData } },
    [
      _vm._l(_vm.columns, function(col, index) {
        return [
          col.slot
            ? _c("el-table-column", {
                key: "column" + index,
                attrs: { prop: col.prop, width: col.width },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function(scope) {
                        return [
                          _c("span", [_vm._v(_vm._s(col.label))]),
                          col.prop === "useFileAuditFlag"
                            ? _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "light",
                                    content: "",
                                    placement: "top"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _vm._v(
                                        "开启后，如果当前审批流程中的审批人已参与了文件发起审批，则不需要再进行用印审批。"
                                      )
                                    ]
                                  ),
                                  _c("i", {
                                    staticClass: "el-icon-question",
                                    staticStyle: {
                                      "font-size": "16px",
                                      "margin-left": "3px",
                                      color: "#a1a1a1",
                                      cursor: "pointer"
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]
                      }
                    },
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(col.slot, {
                            tag: "component",
                            attrs: { data: scope.row },
                            on: { reloadList: _vm.reloadList }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            : col.prop === "_scopeOfUse"
            ? _c("el-table-column", {
                key: "column" + index,
                attrs: { label: col.label, width: col.width },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "top",
                                width: "200",
                                trigger: "hover"
                              },
                              on: {
                                show: function($event) {
                                  return _vm.moreUse(scope.row)
                                }
                              }
                            },
                            [
                              _c("el-card", { staticClass: "box-card" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "clearfix",
                                    attrs: { slot: "header" },
                                    slot: "header"
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          col.label +
                                            "（" +
                                            _vm.userNames.length +
                                            "人）"
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "tag-box" },
                                  _vm._l(_vm.userNames, function(user) {
                                    return _c(
                                      "el-tag",
                                      {
                                        key: user.dingTalkUserId,
                                        staticClass: "text item",
                                        attrs: { size: "small", type: "danger" }
                                      },
                                      [_vm._v(_vm._s(user.dingTalkUserName))]
                                    )
                                  }),
                                  1
                                )
                              ]),
                              _c(
                                "span",
                                {
                                  staticClass: "point",
                                  attrs: { slot: "reference" },
                                  slot: "reference"
                                },
                                [_vm._v(_vm._s(scope.row._scopeOfUse || "-"))]
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            : _c("el-table-column", {
                key: "column" + index,
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: col.prop,
                  label: col.label,
                  width: col.width
                }
              })
        ]
      }),
      _c("no-data", {
        attrs: { slot: "empty", text: "暂无数据" },
        slot: "empty"
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-021c0336", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-021c0336","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/console/dingComponents/FlowTable.vue
// module id = d5re
// module chunks = 7 55 92 247